import { LoadStatus } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { makeObservable, observable, runInAction, when } from 'mobx';
import { DashboardApi, DashboardInfo, PortalStartDateSettingsStore } from '../api';
import { DashboardCustomerAddressesStore } from './dashboard-customer-addresses.store';
import { DashboardInvoicesStore } from './dashboard-invoices.store';

/* we fill info with empty data to show skeletons wile first load */
const defaultInfo = (): DashboardInfo => {
    return {
        customerInvoices: [],
        proposals: [],
        jobs: [],
        serviceAgreements: [],
    };
};
@injectable()
export class DashboardStore {
    @observable loadStatus = LoadStatus.Loading;
    @observable data = defaultInfo();

    constructor(
        @inject(DashboardApi) private dashboardApi: DashboardApi,
        @inject(DashboardCustomerAddressesStore)
        private dashboardCustomerAddressesStore: DashboardCustomerAddressesStore,
        @inject(DashboardInvoicesStore) private dashboardInvoicesStore: DashboardInvoicesStore,
        @inject(PortalStartDateSettingsStore)
        private portalStartDateSettingsStore: PortalStartDateSettingsStore
    ) {
        makeObservable(this);

        this.loadData([]);
    }

    onLocationsChanged = () => {
        const selectedLocationIds = this.dashboardCustomerAddressesStore.getSelectedAddress();
        this.loadData(selectedLocationIds);
        this.dashboardInvoicesStore.loadInvoices(selectedLocationIds);
    };

    private async loadData(selectedLocationIds: number[]) {
        runInAction(() => (this.loadStatus = LoadStatus.Loading));

        try {
            await when(() => this.portalStartDateSettingsStore?.loaded);
            let createdOnOrAt = null;
            if (this.portalStartDateSettingsStore.portalStartDateSettings?.enabled) {
                createdOnOrAt = this.portalStartDateSettingsStore.portalStartDateSettings?.startDate
                    ? new Date(this.portalStartDateSettingsStore.portalStartDateSettings.startDate)
                    : null;
            }
            const data = await this.dashboardApi.getDashboardData(
                selectedLocationIds,
                createdOnOrAt
            );
            runInAction(() => {
                this.loadStatus = LoadStatus.Ok;
                this.data = data;
            });
        } catch {
            runInAction(() => (this.loadStatus = LoadStatus.Error));
        }
    }
}
